import { render } from "./news_card.vue?vue&type=template&id=0fa70c14"
import script from "./news_card.vue?vue&type=script&lang=js"
export * from "./news_card.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__